import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetBadges_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, commentCount?: number | null, versionNumber?: number | null, media?: { __typename?: 'AudioMedia', id: string, duration?: number | null } | null };

export type AssetBadges_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, commentCount?: number | null, versionNumber?: number | null, media?: { __typename?: 'DocumentMedia', id: string, pageCount?: number | null } | null };

export type AssetBadges_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, commentCount?: number | null, versionNumber?: number | null, media?: { __typename?: 'ModelMedia', id: string, duration?: number | null } | null };

export type AssetBadges_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, commentCount?: number | null, versionNumber?: number | null };

export type AssetBadges_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, commentCount?: number | null, versionNumber?: number | null, media?: { __typename?: 'VideoMedia', id: string, duration?: number | null } | null };

export type AssetBadgesFragment = AssetBadges_AudioAsset_Fragment | AssetBadges_DocumentAsset_Fragment | AssetBadges_FileAsset_Fragment | AssetBadges_FolderAsset_Fragment | AssetBadges_ImageAsset_Fragment | AssetBadges_InteractiveAsset_Fragment | AssetBadges_InteractiveLiveAsset_Fragment | AssetBadges_ModelAsset_Fragment | AssetBadges_UnsupportedAsset_Fragment | AssetBadges_VersionStackAsset_Fragment | AssetBadges_VideoAsset_Fragment;

export const AssetBadges = /*#__PURE__*/ gql`
    fragment AssetBadges on Asset {
  id
  commentCount
  versionNumber
  ... on AudioAsset {
    media {
      id
      duration
    }
  }
  ... on DocumentAsset {
    media {
      id
      pageCount
    }
  }
  ... on VideoAsset {
    media {
      id
      duration
    }
  }
  ... on ModelAsset {
    media {
      id
      duration
    }
  }
}
    ` as unknown as DocumentNode<AssetBadgesFragment, unknown>;

        

        
export const useAssetBadgesFragment = (
  input: string | Omit<UseFragmentOptions<AssetBadgesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetBadgesFragment>({
    fragment: AssetBadges,
    fragmentName: 'AssetBadges',
    ...options,
  });
};
  
        